import { scaleToUnit } from "../../../components/data-presentation/util";

export default function KlimatAngular(params) {
  return (
    <div>
      <facility-component
        customer={params.customer}
        demand={scaleToUnit(params.annualHeatingDemand, "MWh", false)}
        dh={params.showDistrictHeating}
        air={params.airSourceHeatPumpEfficiency}
        aircoverage={params.airSourceHeatPumpEnergyCoverage}
        exhaustair={params.exhaustAirHeatPumpEfficiency}
        exhaustaircoverage={params.exhaustAirHeatPumpEnergyCoverage}
        pellets={params.pelletBoilerEfficiency}
        gh={params.groundSourceHeatPumpEfficiency}
        ghcoverage={params.groundSourceHeatPumpEnergyCoverage}
        supplemental={params.supplementalHeatingSource}
        district={params.district}
        building={params.building}
        economic={params.economicProfile}
        api={params.api}
      />
    </div>
  );
}
